export default {
    computed: {
        isDark(){
            return this.$vuetify.theme.dark
        }
    },
    methods: {
        toggleDarkMode(){
            return this.$vuetify.theme.dark = !this.$vuetify.theme.dark
        }
    }
}
